import {
	TRACK_DIFFICULTY_BLACK,
	TRACK_DIFFICULTY_BLUE,
	TRACK_DIFFICULTY_RED,
	TRACK_DIFFICULTY_GREEN,
	TRACK_STATUS_CLOSED,
	TRACK_STATUS_OPEN
} from "../config/constants";

import Track12BBlue from "../components/tracks/blue/Track12BBlue";
import Track1ARed from "../components/tracks/red/Track1ARed";
import Track1BBlack from "../components/tracks/black/Track1BBlack";
import Track2CBlue from "../components/tracks/blue/Track2CBlue";
import Track7BBlue from "../components/tracks/blue/Track7BBlue";
//import TrackMBlue from "../components/tracks/blue/TrackMBlue";
import Track7ABlue from "../components/tracks/blue/Track7ABlue";
import Track5FBlack from "../components/tracks/black/Track5FBlack";
import Track13EBlue from "../components/tracks/blue/Track13EBlue";
import Track1EBlue from "../components/tracks/blue/Track1EBlue";
import Track22ABlack from "../components/tracks/black/Track22ABlack";
import TrackSBlue from "../components/tracks/blue/TrackSBlue";
import Track5CRed from "../components/tracks/red/Track5CRed";
import TrackERed from "../components/tracks/red/TrackERed";
import Track11CBlack from "../components/tracks/black/Track11CBlack";
import TrackKBlue from "../components/tracks/blue/TrackKBlue";
import Track15DRed from "../components/tracks/red/Track15DRed";
import Track14BBlue from "../components/tracks/blue/Track14BBlue";
import Track5DRed from "../components/tracks/red/Track5DRed";
import Track14ABlue from "../components/tracks/blue/Track14ABlue";
import Track1CBlue from "../components/tracks/blue/Track1CBlue";
import TrackBBlue from "../components/tracks/blue/TrackBBlue";
import Track2BRed from "../components/tracks/red/Track2BRed";
import Track2ARed from "../components/tracks/red/Track2ARed";
import TrackDBlue from "../components/tracks/blue/TrackDBlue";
import Track22CBlue from "../components/tracks/blue/Track22CBlue";
import Track22BBlack from "../components/tracks/black/Track22BBlack";
import TrackURed from "../components/tracks/red/TrackURed";
import Track13ARed from "../components/tracks/red/Track13ARed";
import Track13BRed from "../components/tracks/red/Track13BRed";
import Track13CRed from "../components/tracks/red/Track13CRed";
import Track13DRed from "../components/tracks/red/Track13DRed";
import TrackJBlue from "../components/tracks/blue/TrackJBlue";
import Track3ABlue from "../components/tracks/blue/Track3ABlue";
import Track16BBlack from "../components/tracks/black/Track16BBlack";
import Track16CBlack from "../components/tracks/black/Track16CBlack";
import Track16ARed from "../components/tracks/red/Track16ARed";
import Track11FBlue from "../components/tracks/blue/Track11FBlue";
import Track16EBlack from "../components/tracks/black/Track16EBlack";
import Track11ERed from "../components/tracks/red/Track11ERed";
import Track16DBlack from "../components/tracks/black/Track16DBlack";
import Track12DRed from "../components/tracks/red/Track12DRed";
import Track11DRed from "../components/tracks/red/Track11DRed";
import Track12ARed from "../components/tracks/red/Track12ARed";
import Track12CRed from "../components/tracks/red/Track12CRed";
import Track15CRed from "../components/tracks/red/Track15CRed";
import Track15BRed from "../components/tracks/red/Track15BRed";
import Track15EBlue from "../components/tracks/blue/Track15EBlue";
import Track15ARed from "../components/tracks/red/Track15ARed";
import Track5BBlue from "../components/tracks/blue/Track5BBlue";
import Track17ABlue from "../components/tracks/blue/Track17ABlue";
import Track5EBlack from "../components/tracks/black/Track5EBlack";
import Track5GRed from "../components/tracks/red/Track5GRed";
import Track5KBlue from "../components/tracks/blue/Track5KBlue";
import Track5HBlack from "../components/tracks/black/Track5HBlack";
import Track5ABlue from "../components/tracks/blue/Track5ABlue";
import Track8CRed from "../components/tracks/red/Track8CRed";
import Track8BRed from "../components/tracks/red/Track8BRed";
import Track8DBlue from "../components/tracks/blue/Track8DBlue";
import Track8ARed from "../components/tracks/red/Track8ARed";
import TrackGBlue from "../components/tracks/blue/TrackGBlue";
import Track11BBlack from "../components/tracks/black/Track11BBlack";
import TrackFBlue from "../components/tracks/blue/TrackFBlue";
import Track7CBlue from "../components/tracks/blue/Track7CBlue";
import Track7DBlue from "../components/tracks/blue/Track7DBlue";
import Track7EGreen from "../components/tracks/green/Track7EGreen";
import Track1DGreen from "../components/tracks/green/Track1DGreen";
import Track2DGreen from "../components/tracks/green/Track2DGreen";
import Track11ARed from "../components/tracks/red/Track11ARed";
import TrackMBlue from "../components/tracks/blue/TrackMBlue";
import Track9ABlue from "../components/tracks/blue/Track9ABlue";
import Track3DBlue from "../components/tracks/blue/Track3DBlue";

const defaultTrack = {
	status: TRACK_STATUS_OPEN,
	isShow: true,
}

export const localTracksData = {
	'Track12BBlue': {
		...defaultTrack,
		difficulty: TRACK_DIFFICULTY_BLUE,
		component: Track12BBlue
	},
	'Track1ARed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track1ARed
	},
	'Track11ARed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track11ARed
	},
	'Track1BBlack': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLACK,
		isShow: true,
		component: Track1BBlack
	},
	'Track2CBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track2CBlue
	},
	'Track7BBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track7BBlue
	},
	'TrackMBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: TrackMBlue
	},
	'Track7EGreen': {
		status: TRACK_STATUS_CLOSED,
		difficulty: TRACK_DIFFICULTY_GREEN,
		isShow: true,
		component: Track7EGreen
	},
	'Track7ABlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLACK,
		isShow: true,
		component: Track7ABlue
	},

	'Track5FBlack': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track5FBlack
	},
	'Track13EBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track13EBlue
	},
	'Track1EBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track1EBlue
	},
	'Track22ABlack': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLACK,
		isShow: true,
		component: Track22ABlack
	},
	'TrackSBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: TrackSBlue
	},
	'Track5CRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track5CRed
	},
	'TrackERed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: TrackERed
	},
	'Track11CBlack': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLACK,
		isShow: true,
		component: Track11CBlack
	},
	'TrackKBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: TrackKBlue
	},
	'Track15DRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track15DRed
	},
	'Track14BBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track14BBlue
	},
	'Track5DRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track5DRed
	},
	'Track14ABlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track14ABlue
	},
	'Track1CBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track1CBlue
	},
	'TrackBBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: TrackBBlue
	},
	'Track2BRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track2BRed
	},
	'Track2ARed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track2ARed
	},
	'TrackDBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: TrackDBlue
	},
	'Track22CBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track22CBlue
	},
	'Track22BBlack': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLACK,
		isShow: true,
		component: Track22BBlack
	},
	'TrackURed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: TrackURed
	},
	'Track13ARed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track13ARed
	},
	'Track13BRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track13BRed
	},
	'Track13CRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track13CRed
	},
	'Track13DRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track13DRed
	},
	'TrackJBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: TrackJBlue
	},
	'Track3ABlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track3ABlue
	},
	'Track3DBlue': {
		...defaultTrack,
		difficulty: TRACK_DIFFICULTY_BLUE,
		component: Track3DBlue
	},
	'Track16BBlack': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLACK,
		isShow: true,
		component: Track16BBlack
	},
	'Track16DBlack': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLACK,
		isShow: true,
		component: Track16DBlack
	},
	'Track16CBlack': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLACK,
		isShow: true,
		component: Track16CBlack
	},

	'Track16ARed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track16ARed
	},
	'Track11BBlack': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLACK,
		isShow: true,
		component: Track11BBlack
	},
	'Track11FBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track11FBlue
	},
	'Track16EBlack': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track16EBlack
	},
	'Track11ERed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track11ERed
	},

	'TrackGBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: TrackGBlue
	},
	'Track12DRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track12DRed
	},
	'Track11DRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track11DRed
	},
	'Track12ARed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track12ARed
	},
	'Track12CRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track12CRed
	},
	'Track15BRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track15BRed
	},
	'Track15CRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track15CRed
	},
	'Track15EBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track15EBlue
	},
	'Track15ARed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track15ARed
	},
	'Track17ABlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_GREEN,
		isShow: true,
		component: Track17ABlue
	},
	'Track17AGreen': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_GREEN,
		isShow: true,
		component: Track17ABlue
	},
	'Track5EBlack': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLACK,
		isShow: true,
		component: Track5EBlack
	},
	'Track5GRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track5GRed
	},
	'Track5KBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track5KBlue
	},
	'Track5BBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track5BBlue
	},
	'Track5HBlack': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLACK,
		isShow: true,
		component: Track5HBlack
	},
	'Track5ABlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track5ABlue
	},
	'Track8CRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track8CRed
	},
	'Track8BRed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track8BRed
	},
	'Track8ARed': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_RED,
		isShow: true,
		component: Track8ARed
	},
	'Track8DBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track8DBlue
	},
	'Track9ABlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track9ABlue
	},
	'TrackFBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: TrackFBlue
	},
	'Track7CBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_BLUE,
		isShow: true,
		component: Track7CBlue
	},
	'Track7DBlue': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_GREEN,
		isShow: true,
		component: Track7DBlue
	},
	'Track7DGreen': {
		status: TRACK_STATUS_OPEN,
		difficulty: TRACK_DIFFICULTY_GREEN,
		isShow: true,
		component: Track7DBlue
	},

	'Track1DGreen': {
		status: TRACK_STATUS_CLOSED,
		difficulty: TRACK_DIFFICULTY_GREEN,
		isShow: true,
		component: Track1DGreen
	},
	'Track2DGreen': {
		status: TRACK_STATUS_CLOSED,
		difficulty: TRACK_DIFFICULTY_GREEN,
		isShow: true,
		component: Track2DGreen
	}
};
